import { Box } from '@mui/material';
const BookingWrapMessage = ({ children, borderColor = 'success.main', sx = {} }) => {
  return <Box sx={{ my: 1, py: 2, px: 1, border: '2px dotted', borderColor: borderColor, borderRadius: 1, ...sx }}>{children}</Box>;
};

export default BookingWrapMessage;
